/**
 * Covers functionality related to the hero paragraph.
 * Mostly just the jump links option right now.
 *
 * @author Todd Miller <todd.miller@tricomb2b.com>
 */

import debounce from 'debounce';

(function ($, drupalSettings) {
  'use strict';

  let $sliders;
  let $jumpMenuDesktop;
  let isLoggedInUser;

  Drupal.behaviors.initializeHero = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  /**
   * Cache elements, attach event handlers.
   */
  function initialize() {
    $sliders = $('.jump-link-menu-mobile');
    $jumpMenuDesktop = $('.jump-link-menu');

    if (!$sliders.length) return false;

    isLoggedInUser = drupalSettings.user.uid == 0 ? false : true;

    $sliders.each(function () {
      const $el = $(this);

      $el.slick({
        centerMode: false,
        slidesToShow: 2,
        infinite: false,
        slidesToScroll: 1,
        variableWidth: true,
        swipeToSlide: true,
        prevArrow: false,
        nextArrow: false,
      });
    });

    window.addEventListener('scroll', debounce(makeSticky, 10));
  }

  /**
   * Sticky the jump links menu if needed.
   */
  function makeSticky() {
    const scroll_top = $(window).scrollTop();

    if (isLoggedInUser) {
      if (scroll_top >= 400) $sliders.addClass('is-sticky');
      else $sliders.removeClass('is-sticky');

      if (scroll_top >= 460) $jumpMenuDesktop.addClass('is-sticky');
      else $jumpMenuDesktop.removeClass('is-sticky');
    } else {
      if (scroll_top >= 400) $sliders.addClass('is-sticky');
      else $sliders.removeClass('is-sticky');

      if (scroll_top >= 430) $jumpMenuDesktop.addClass('is-sticky');
      else $jumpMenuDesktop.removeClass('is-sticky');
    }
  }
})(jQuery, drupalSettings);
